const api= process.env.REACT_APP_API_URL;
// const api = "http://192.168.1.9/PuZzLe Technology/endpoints/";
export default  api;
// Overlay  -> 40
// Filters  -> 50
// SearchIn -> 50